import axios from 'axios';

import { action, observable } from 'mobx';
import { Config } from '../config';

 class App {
  @observable data = {};

  @action
  populate = async (props) => {
    let slug = props && props.params ? props.params.slug : 'more-than-height';
    if (slug === "ar") slug = "more-than-height";
    const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.wp}${Config.endpoint.wordpress.pages}?slug=${slug}`;
    const response = await axios.get(endpoint)
    const page = response.data[0];

    this.data = {
      env: Config.environment,
      slug: slug,
      page: page,
      head: {
        title: page ? page.title.rendered : ''
      },
      colorScheme: page ? page.acf.lxl_colorscheme : 'ajaz'
    }
  }
}

const AppStore = new App();
export default AppStore;
